/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Boiler_Warning_1Inputs */



/**
* | output |
* | --- |
* | "Without run feedback and with the physical switch in manual mode, the boiler state cannot be determined" |
*
* @param {Boiler_Warning_1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const boiler_warning_1 = /** @type {((inputs?: Boiler_Warning_1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Boiler_Warning_1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Without run feedback and with the physical switch in manual mode, the boiler state cannot be determined")
	return /** @type {LocalizedString} */ ("En l'absence de retour de marche et avec le commutateur physique en manuel, il est impossible de déterminer l'état de la chaudière")
});